module.exports = "../../app/cells/pages/contests/index/with_guides_cell.rb";